import React from "react";
import { Slide } from "react-slideshow-image";
import Image from "next/image";
import "react-slideshow-image/dist/styles.css";
import LinkButton from "../button";
import { configuration } from "../../helpers/config";
import { useState, useEffect } from "react";
import useIsMobile from "../../hooks/useIsMobile";
import Link from "next/link";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// slider component to show inside of brand pages .
export default function BrandSlider(data) {
  const [showindicator, setshowindicator] = useState(false);
  const mobile = useIsMobile();
  const [isLoading, setIsLoading] = useState(true);
    const [hideImage, setHideImage] = useState(false);
    const [isLoadingMobile, setIsLoadingMobile] = useState(true);

  useEffect(() => {
    if (data.sliders.length > 1) {
      setshowindicator(true);
    }
  }, [data]);

  return (
    <div
      className="container mx-auto mt-[70px] mb-[130px] brand_slider"
      id="slider"
    >
      <Slide
        cta
        arrows={false}
        autoplay="false"
        indicators={showindicator ? true : false}
        infinite={showindicator ? true : false}
        className="slide-container"
      >
        {/*mapping data to show inside slider*/}
        {data?.sliders?.map((v, index) => {
          return (
            <div
              key={index}
              className="each-slide-effect slider md:pr-[20px] lg:pr-[20px] xl:pr-[20px]"
            >
              <div className="md:flex md:items-center md:rounded-[5px]">
              {v?.cta_link ?
  
  <Link  
  
  className="cursor-pointer"
  
  href={v?.cta_link}
  
   >
  
   <div className={`hidden slider__image md:flex lg:w-[60%] md:w-[60%] ${v?.cta_link ? "cursor-pointer" : ""}`}>
   {/* {isLoading && !hideImage && <Skeleton height={380} width={1000} />} */}
                               {!hideImage && (
   <img
  
     width={1000}
  
     height={380}
  
     src={ v.url? `${configuration.IMG_URL}${v.url}` : "" }
  
     alt={v.img_alt_text}
  
     // layout="fill"
  
     // objectFit="cover"
     onError={() => setHideImage(true)}
     className={isLoading ? "hidden" : "block"}
     onLoad={() => setIsLoading(false)}
   />
  )}
  
  </div>
  
  </Link>
  
  :
	  
                <div className="hidden slider__image md:flex lg:w-[60%] md:w-[60%]">
                  {/* {isLoading && !hideImage && <Skeleton height={380} width={1000} />} */}
                               {!hideImage && (
                  <Image
                    width={!isLoading?1000:0}
                    height={!isLoading?380:0}
                    src={v.url? `${configuration.IMG_URL}${v.url}` : ""}
                    alt={v.img_alt_text}
                    onError={() => setHideImage(true)}
                    className={isLoading ? "hidden" : "block"}
                    onLoad={() => setIsLoading(false)}
                    // layout="fill"
                    // objectFit="cover"
                  />
                )}
                </div>
        }
 <div className="block w-full slider__image md:hidden">
  {/* Show Skeleton only when the image is loading */}
  {/* {isLoadingMobile && !hideImage && <Skeleton height={651} width={651} />} */}

  {/* Show Image once it's loaded */}
  {!hideImage && (
    <Image
      width={651}
      height={651}
      layout="responsive"
      src={
        mobile
          ? v.urlMobile
            ? `${configuration.IMG_URL}${v.urlMobile}`
            : ""
          : v.url
          ? `${configuration.IMG_URL}${v.url}`
          : ""
      }
      alt={v.img_alt_text}
      onError={() => setHideImage(true)}
      className={isLoadingMobile ? "hidden" : "block"}
      onLoad={() => setIsLoadingMobile(false)} // Ensure state updates properly
    />
  )}
</div>


                <div className="slider__details md:pr-[40px] md:mt-0 mt-[20px] md:pl-[50px] lg:w-[40%] md:w-[40%]">
                  <div>
                    <h3 className="slider__details--title">{v.title}</h3>
                  </div>
                  <div className="flex justify-around w-full md:flex-col">
                    <p className="slider__details--description">{v.desc}</p>
                    {v?.cta_link ? (
                      <div className="slider__details--cta">
                        <LinkButton
                          type={"button_dark_arrow"}
                          Id={"ModelSlider" + index}
                          buttontext={v?.cta_text}
                          href={v?.cta_link}
                          classname="button_dark_arrow"
                          target={v.target === "self" ? "" : "_blank"}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slide>
    </div>
  );
}
